export default {
  docNeeded: 'Belge Kontrol Bekliyor',
  approvalStatus: {
    UPDATE_WAIT_FOR_APPROVAL: 'İçerik Kontrol Bekliyor',
    APPROVED: 'İçerik Kontrol Edildi',
    REJECTED: 'İçerik Kontrol Edildi',
    IGNORE: 'İçerik Kontrol Edildi',
  },
  lockReason: {
    DRAFT: 'Taslak',
    PREPARING: 'Hazırlanıyor',
    APPROVED: 'Onaylandı',
    CANCELLED: 'İptal Edildi',
    PENDING: 'Bekliyor',
    REJECTED: 'Reddedildi',
    ON_SALE: 'Satışta',
    COMPLETED: 'Kapandı',
    CLOSED: 'Kapandı',
    SUPPLIER_DRAFT: 'Draft Tedarikçi',
    CRITICAL_SALE_PRICE_CHANGE: 'Fiyat Hatası',
    UNSUPPLIED_PRODUCT: 'Tedarik Problemi',
    SUPPLIER_PASSIVATION: 'Askıya Alınan Satıcı',
    LOW_SALE_PRICING: 'Düşük Fiyatlandırma',
    HIGH_SALE_PRICING: 'Yüksek Fiyatlandırma',
  },
  waitingForSelling: 'İçerik onaylandı, satışa çıkması bekleniyor.',
  waitingForContent: 'İçerik onayı bekliyor.',
  needProductPrice: 'Fiyat girmeniz gerekmektedir.',
  needProductStock: 'Stok girmeniz gerekmektedir.',
  components: {
    campaignLabel: {
      title: 'Bu ürün bir kampanyada yer almaktadır.',
      betweenDate: 'tarihleri arasında',
      priceWithCampaign: 'kampanyalı fiyatı:',
    },
    maxPriceLabel: {
      title: 'Trendyol ile maksimum fiyat anlaşmanız vardır.',
      betweenDate: 'tarihleri arasında',
      maxPriceText: 'girebileceğiniz maksimum fiyatı:',
    },
  },
};
